import type { ReactNode } from 'react'
import { isValidElement } from 'react'

function nodeToString(node: ReactNode): string {
  let string = ''

  if (typeof node === 'string') {
    string = node
  } else if (typeof node === 'number') {
    string = node.toString()
  } else if (node instanceof Array) {
    string = node.reduce(
      (previous, current) => (previous += ' ' + nodeToString(current)),
      string,
    ) as string

    string = string.trim()
  } else if (isValidElement(node)) {
    string += nodeToString(node.props.children)
  }

  return string
}

export default nodeToString
